var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmericanExpress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 24,
    viewBox: "0 0 56 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.14103 5.53845L0.930191 19.1788H8.36609L9.2879 17.004H11.3948L12.3166 19.1788H20.5022V17.5172L21.2315 19.1788H25.4657L26.1949 17.484V19.1788H43.2173L45.287 17.0603L47.2255 19.1788L55.9692 19.1963L49.737 12.3969L55.9655 5.53845H47.3585L45.3437 7.61722L43.4666 5.53845H24.9494L23.3597 9.05907L21.7319 5.53845H14.3118V7.14184L13.4877 5.53845H7.14103ZM8.58003 7.47691H12.2078L16.3275 16.7261V7.47691H20.2985L23.4807 14.1092L26.4098 7.47691H30.3603V17.2615H27.9567L27.9372 9.59168L24.4322 17.2615H22.2817L18.7572 9.59168V17.2615H13.8123L12.8747 15.0674H7.81356L6.87407 17.2615H4.22491L8.58003 7.47691ZM42.3346 7.47691H32.5565V17.2615H42.183L45.2851 14.0197L48.2766 17.2615H51.402L46.8599 12.3988L51.3992 7.47691H48.4096L45.3242 10.68L42.3346 7.47691ZM10.3437 9.13107L8.67491 13.0403H12.0106L10.3437 9.13107ZM34.975 11.2883V9.5003H41.0742L43.7354 12.3618L40.9551 15.2308H34.975V13.2803H40.3077V11.2883H34.975Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpress);
export default __webpack_public_path__ + "static/media/american_express.12d47bc1.svg";
export { ForwardRef as ReactComponent };